import React from "react";
import { MessageCircle } from "lucide-react";
import { BRAND } from "@/data/brand";

export default function WhatsAppFloat() {
  return (
    <a
      href={BRAND.whatsapp}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-40 inline-flex items-center gap-2 bg-pshl-electric hover:bg-pshl-electric/90 text-white font-display uppercase tracking-[0.18em] text-xs pl-4 pr-5 py-3 shadow-[0_0_32px_rgba(0,85,255,0.35)] hover:shadow-[0_0_42px_rgba(0,85,255,0.6)] transition-all"
    >
      <MessageCircle className="h-4 w-4" />
      <span className="hidden sm:inline">Chat with PSHL</span>
      <span className="sm:hidden">Chat</span>
    </a>
  );
}
